export default import.meta.ROLLUP_FILE_URL_skog$$OoyYMCf6ZayJRrRg